import React, { useEffect } from 'react';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgmissionStatement from '../../assets/MissionStatement/imgMissionStatement.jpg';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import imgTogetherness from '../../assets/MissionStatement/imgToghetherness2.jpg';
import imgResponsibility from '../../assets/MissionStatement/imgResponsibility2.jpg';
import imgReliability from '../../assets/MissionStatement/imgReliability2.jpg';
import imgEnviromentalAwareness from '../../assets/MissionStatement/imgEnvironmentalawareness2.jpg';
import imgRD from '../../assets/MissionStatement/imgR&D2.jpg';
import imgFlexibility from '../../assets/MissionStatement/imgFlexibility2.jpg';
import MissionStatementComponentCardGrid from '../../Components/MissionStatementComponent/MissionStatementComponentCardGrid';

function GroupMissionStatement() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const Togetherness = {
        image: imgTogetherness,
        title: 'Togetherness',
        listItems: [
            'We treat each other with appreciation and respect.',
            'We act in a cooperative manner and support each other',
            'We communicate with one another openly and honestly.',
            'We make sure that we and others are always well-informed.',
            'We are part of a larger whole'
        ]
    };

    const Responsibility = {
        image: imgResponsibility,
        title: 'Responsibility',
        listItems: [
            'We deliver quality and expect the same from our partners',
            'We encourage our staff to work on their own initiative.',
            'We question things critically and respect the opinions of others.',
            'We are aware of our responsibilities towards colleagues and partners and implement these responsibilities.'
        ]
    };

    const Reliability = {
        image: imgReliability,
        title: 'Reliability',
        listItems: [
            'We keep our promises',
            'We trust our colleagues and business partners',
            'We represent security.'
        ]
    };

    const EnviromentalAwareness = {
        image: imgEnviromentalAwareness,
        title: 'Enviromental Awareness',
        listItems: [
            'We conserve natural resources.',
            'We avoid risks to the environment and to health.',
            'We promote energy efficiency in hydraulics with regard to our customers, products and services.',
            'We ensure that our processes are sustainable.'
        ]
    };

    const RD = {
        image: imgRD,
        title: 'Development',
        listItems: [
            'We develop innovative products and services.',
            'We continuously expand our professional expertise.',
            'We encourage and challenge our workforce.',
            'We support our business partners with consultancy and training',
            'We all work together to ensure the success of HANSA‑FLEX.'
        ]
    };

    const Flexibility = {
        image: imgFlexibility,
        title: 'Flexibility',
        listItems: [
            'We respond to the individual requirements of our partners',
            'We offer our colleagues flexible opportunities to work throughout the group',
            'We identify changes at an early stage and respond immediately'
        ]
    };

    const data = [Togetherness, Responsibility, Reliability, EnviromentalAwareness, RD, Flexibility];

    return (
        <div>
            <div>
                <CenterStage
                    imageSrc={imgmissionStatement}
                    title={"The HANSA-FLEX Mission Statement"}
                    paragraph={"The HANSA‑FLEX Mission Statement forms the orientation framework for the daily actions of all employees worldwide. The underlying values and principles were developed in joint workshops by employees, managers and the owner families. Together with our HANSA‑FLEX Code of Conduct, we have a stable framework of values forming the basis of our corporate culture."}
                />
            </div>

            <div className='div-gray'>
                <SectionHeader
                    title={"OUR DRIVE IS IN OUR DNA"}
                    subtitle={"All other values we identify with and the matters we do not tolerate are defined in our code of conduct. This supplements our mission statement. Together they form the foundations for our everyday activities. All employees are under an obligation to communicate their contents and ensure they are complied with. This applies both internally to all colleagues and externally in relationships with our business partners."}
                />

                <MissionStatementComponentCardGrid data={data} columns={2} />
            </div>
        </div>
    );
}

export default GroupMissionStatement;
